import loadable from '@loadable/component';

export const LazyCatalogProductsIndex = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/productsindex" */
      '.'
    ),
);
